import { Typography } from '@material-ui/core';
import React from 'react';

const CreditsInfo = ({ classes, creditsRemaining, creditsNeeded, usagePerDay, showFreeToolsUsage = false }) => {
  const formatCredits = (creditsRemaining) => {
    return creditsRemaining < 10 ? (creditsRemaining < 0 ? `00` : `0${creditsRemaining}`) : creditsRemaining;
  };
  return (
    <div className={classes.creditsContainer}>
      <div className="d-flex j-flex-start">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
          <g clip-path="url(#clip0_2550_3409)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M2.84282 0.961349C3.06232 0.741846 3.36003 0.61853 3.67045 0.61853H14.2632C14.5734 0.618804 14.8713 0.742196 15.0906 0.961589L17.9521 3.82313C18.0611 3.93194 18.1475 4.06118 18.2064 4.20346C18.2653 4.34573 18.2956 4.49822 18.2955 4.6522V10.3344C18.2955 10.6796 18.0156 10.9594 17.6705 10.9594C17.3253 10.9594 17.0455 10.6796 17.0455 10.3344V4.68423L17.0685 4.70729C17.0612 4.69996 17.0555 4.69127 17.0515 4.68172C17.0476 4.6722 17.0455 4.662 17.0455 4.65171V4.68423L14.2298 1.86853H14.2632C14.2422 1.86851 14.2216 1.86022 14.2067 1.84547M14.2067 1.84547L14.2298 1.86853H3.75V1.78898C3.75 1.81008 3.74162 1.83031 3.7267 1.84523C3.71178 1.86015 3.69155 1.86853 3.67045 1.86853H3.75V18.8003H3.67045C3.69155 18.8003 3.71178 18.8087 3.7267 18.8236C3.74162 18.8386 3.75 18.8588 3.75 18.8799V18.8003H9.48864C9.83381 18.8003 10.1136 19.0802 10.1136 19.4253C10.1136 19.7705 9.83381 20.0503 9.48864 20.0503H3.67045C3.36003 20.0503 3.06232 19.927 2.84282 19.7075C2.62331 19.488 2.5 19.1903 2.5 18.8799V1.78898C2.5 1.47856 2.62332 1.18085 2.84282 0.961349"
              fill="#141414"
            />
            <path
              d="M8.4659 12.3345L10.5492 11.1678L9.38257 13.2512L10.5492 15.3345L8.4659 14.1678L6.38257 15.3345L7.54923 13.2512L6.38257 11.1678L8.4659 12.3345Z"
              fill="#141414"
            />
            <path
              d="M13.1569 14.5953L11.8864 13.3248L12.9903 12.221L14.2607 13.4914L13.1569 14.5953ZM12.6206 11.7368L11.4022 12.9551C11.1992 13.1478 11.1992 13.4862 11.4022 13.6893L17.4784 19.7655C17.6815 19.9686 18.0199 19.9686 18.2126 19.7655L19.431 18.5471C19.634 18.3545 19.634 18.0161 19.431 17.813L13.3547 11.7368C13.1517 11.5337 12.8132 11.5337 12.6206 11.7368Z"
              fill="#141414"
            />
            <path
              d="M7.62505 6.7731L4.99991 7.16828L7.03166 5.45962L6.63647 2.83447L8.34514 4.86622L10.9703 4.47104L8.93853 6.17971L9.33371 8.80485L7.62505 6.7731Z"
              fill="#141414"
            />
            <path
              d="M13.0583 9.50612L10.8333 9.84106L12.5554 8.39285L12.2205 6.16785L13.6687 7.8899L15.8937 7.55496L14.1716 9.00317L14.5066 11.2282L13.0583 9.50612Z"
              fill="#141414"
            />
          </g>
          <defs>
            <clipPath id="clip0_2550_3409">
              <rect width="20" height="20" fill="white" transform="translate(0 0.334473)" />
            </clipPath>
          </defs>
        </svg>
        <Typography
          className={showFreeToolsUsage || usagePerDay > 10 ? classes.requiredCredits : classes.requiredCreditsOnlyText}
        >
          Uses {creditsNeeded > 1 ? `${creditsNeeded} Credits` : `${creditsNeeded}  Credit`}
        </Typography>
      </div>
      {showFreeToolsUsage || usagePerDay > 10 ? (
        <div>
          <Typography className={classes.creditsConsumedText}>
            {' '}
            <span className={`ft-wt-500 ${classes.creditsRemaining}`}>{formatCredits(creditsRemaining)}</span>/
            {formatCredits(usagePerDay)} {showFreeToolsUsage ? 'FREE' : 'daily'} credits remaining
          </Typography>
        </div>
      ) : null}
    </div>
  );
};

export default CreditsInfo;
